import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../../layout/akkhor";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import Moment from "react-moment";
import * as XLSX from 'xlsx';
import { confirmAlert } from "react-confirm-alert";
import { Spinner } from "react-bootstrap";
import { jwtDecode } from "jwt-decode";

export default function TheoDoiCheckIn() {
    const { user } = useSelector((state) => state.auth);
    const { id } = useParams();
    const [title, setTitle] = useState('');
    const [code, setCode] = useState('');
    const [department, setDepartment] = useState('');
    const [filterShow, setFilterShow] = useState(false)
    const [listData, setListData] = useState([])
    const [filteredData, setFilteredData] = useState([]) // Data sau khi lọc
    const [loading, setLoading] = useState(null)
    const socketRef = useRef(null);

    const applyFilter = (data, titleVal, codeVal, departmentVal) => {
        let filtered = [...data];
        if (titleVal !== '') {
            filtered = filtered.filter((item) => item.fullname.toLowerCase().includes(titleVal.toLowerCase()));
        }
        if (codeVal !== '') {
            filtered = filtered.filter((item) => item.code.toLowerCase().includes(codeVal.toLowerCase()));
        }
        if (departmentVal !== '') {
            filtered = filtered.filter((item) => item.department.toLowerCase().includes(departmentVal.toLowerCase()));
        }
        return filtered;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Lọc lại dữ liệu khi có thay đổi ở ô tìm kiếm
        setFilteredData(applyFilter(listData, title, code, department));
    };

    const fetchList = () => {
        if (!(id > 0)) return;
        Axios.get(URL_LIST_ALL + "checkin_user?limit=10000000&orderby=timecheckin-desc&checkin_id=" + id, user.config)
            .then(async (res) => {
                if (res.data.status === "success") {
                    setListData(res.data.data);
                    // Giữ lại filter đang áp dụng (nếu có) khi có dữ liệu mới từ realtime,
                    // không để mất điều kiện tìm kiếm admin đang xem.
                    setFilteredData(applyFilter(res.data.data, title, code, department));
                } else {
                    console.log(res.data.message);
                }
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        fetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, id]);

    // Realtime: khi có ai quét mã checkin đúng phiên (checkin_id) đang xem -> tự nạp lại danh
    // sách (đã sort timecheckin DESC ở BE nên người mới quét tự lên đầu bảng).
    useEffect(() => {
        if (!(id > 0)) return;
        let closed = false;
        const connectSocket = () => {
            const ws = new WebSocket('wss://socket.bhsgroup.vn');
            socketRef.current = ws;
            ws.onmessage = (evt) => {
                try {
                    const payload = jwtDecode(evt.data);
                    const data = payload && payload.data;
                    if (payload && payload.channel === 'bhs_socket' && data
                        && data.action === 'checkin_user' && String(data.checkin_id) === String(id)) {
                        fetchList();
                    }
                } catch (e) { /* ignore malformed socket payload */ }
            };
            ws.onclose = () => {
                if (!closed) setTimeout(connectSocket, 1000);
            };
        };
        connectSocket();
        return () => {
            closed = true;
            if (socketRef.current) socketRef.current.close();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);
    // Hàm xuất file Excel
    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(
            listData.map(item => ({
                "Họ tên": item.fullname,
                "Mã nhân viên": item.code,
                "Email": item.email,
                "Chức vụ": item.chucvu,
                "Đơn vị": item.department,
                "Công ty": item.company_name,
                "Check-in": item.timecheckin ? new Date(item.timecheckin).toLocaleString('vi-VN') : '', // Định dạng theo múi giờ VN
                "Check-out": item.timecheckout ? new Date(item.timecheckout).toLocaleString('vi-VN') : '',  // Định dạng theo múi giờ VN,
                "Trạng thái": item.timecheckin ? "Có mặt" : "Không có mặt",
                // Thư viện xlsx (bản community) không hỗ trợ tô màu cell -> đánh dấu bằng cột chữ
                // thay cho màu đỏ trên web, để người xem Excel vẫn nhận biết được dòng đặc biệt.
                "Trạng thái đăng ký": Number(item.status) === 0 ? "Ngoài danh sách đăng ký" : "Hợp lệ"
            }))
        );

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Check-in Data");

        // Xuất file với tên "checkin_data.xlsx"
        XLSX.writeFile(workbook, "checkin_data.xlsx");
    };

    const actionCheckin = (user_id) => {
        setLoading(user_id)
        const values = { checkin_id: id, user_id: user_id }
        Axios.post(URL_LIST_ALL + 'checkin_user', values, user.config).then(res => {
            setLoading(null)
            if (res.data.status === "success") {
                confirmAlert({
                    title: "Thông báo",
                    message: "Bạn đã checkin thành công",
                    buttons: [{
                        label: "OK",
                        onClick: () => {
                            // window.location.reload()
                        },
                    }, { label: "Không" },
                    ],
                });
            } else alert(res.data.message);
        }).catch((err) => { console.log(err); setLoading(null) });
    }
    return (
        <AkkhorLayout idrole="checkin">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        Theo dõi Checkin
                    </li>
                </ul>
            </div>
            <div className="card card-filter mb-3">
                <div className="card-header">
                    <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                        <div className="mr-auto">
                            <h3 className="title">Tìm kiếm</h3>
                        </div>
                        <button className="btn btn-sm btn-defaul" onClick={() => setFilterShow(!filterShow)}>
                            <span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span>
                        </button>
                    </div>
                </div>
                <div className={filterShow ? "card-body" : 'hidden-filter'}>
                    <form className="new-added-form" method="get">
                        <div className="row">
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
                                <label>Tên nhân viên</label>
                                <input
                                    type="text"
                                    placeholder="Tên nhân viên"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    className="form-control height32"
                                    autoComplete="off"
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
                                <label>Mã nhân viên</label>
                                <input
                                    type="text"
                                    placeholder="Mã nhân viên"
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                    className="form-control height32"
                                    autoComplete="off"
                                />
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-6 col-12 form-group">
                                <label>Phòng ban</label>
                                <input
                                    type="text"
                                    placeholder="Tên phòng ban"
                                    value={department}
                                    onChange={(e) => setDepartment(e.target.value)}
                                    className="form-control height32"
                                    autoComplete="off"
                                />
                            </div>
                            <div className="col-12 ">
                                <button
                                    type="submit"
                                    onClick={handleSubmit}
                                    className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark"
                                >
                                    Lọc
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className="w-100 d-flex justify-content-end">
                <button type="button" className="btn btn-sm btn-primary" onClick={() => exportToExcel()}>Xuất file</button>
            </div>
            {/* <Spinner /> */}
            <div className="d-none d-sm-block">
                <table className="table table-striped table-bordered table-hover mt-2">
                    <thead>
                        <tr>
                            <th>STT</th>
                            <th>Họ tên</th>
                            <th>Mã nhân viên</th>
                            <th>Email</th>
                            <th>Chức vụ</th>
                            <th>Đơn vị</th>
                            <th>Công ty</th>
                            <th>Check-in</th>
                            <th>Check-out</th>
                            <th>Trạng thái</th>
                            <th>#</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length === 0 ? (
                            <tr>
                                <td colSpan="11" className="text-center">Không có dữ liệu</td>
                            </tr>
                        ) : (
                            filteredData.map((item, index) => (
                                <tr key={item.user_id} className={Number(item.status) === 0 ? "table-danger" : ""} title={Number(item.status) === 0 ? "Check-in ngoài danh sách được mời (user_join)" : ""}>
                                    <td>{index + 1}</td>
                                    <td>{item.fullname}</td>
                                    <td>{item.code}</td>
                                    <td>{item.email}</td>
                                    <td>{item.chucvu}</td>
                                    <td>{item.department}</td>
                                    <td>{item.company_name}</td>
                                    <td>{item.timecheckin && <Moment format="HH:mm DD/MM/YYYY">{item.timecheckin}</Moment>}</td>
                                    <td>{item.timecheckout && <Moment format="HH:mm DD/MM/YYYY">{item.timecheckout}</Moment>}</td>
                                    <td>{item.timecheckin ? "Có mặt" : "Vắng mặt"}</td>
                                    <td> <button type="button" className="btn btn-sm btn-success" disabled={loading == item.user_id ? true : false} onClick={() => actionCheckin(item.user_id)}>
                                        <i className="fas fa-sign-in-alt"></i> {loading == item.user_id ? <Spinner /> : "Checkin"}</button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
            <div className="d-block d-sm-none table-mobile">
                <div className="w-100 list">
                    {filteredData.length === 0 ? (
                        <div className="w-100">
                            <h3 className="text-center">Không có dữ liệu</h3>
                        </div>
                    ) : (
                        filteredData.map((item, index) => (
                            <div className="list-item shaddow mt-2" key={item.id} style={Number(item.status) === 0 ? { backgroundColor: '#f8d7da' } : undefined} title={Number(item.status) === 0 ? "Check-in ngoài danh sách được mời (user_join)" : ""}>
                                <div className="w-100 d-row d-flex">
                                    <div className="item-left" >STT</div>
                                    <div className="item-right">{index + 1}</div>
                                </div>
                                <div className="w-100 d-row d-flex">
                                    <div className="item-left">Họ tên</div>
                                    <div className="item-right">{item.fullname}</div>
                                </div>
                                <div className="w-100 d-row d-flex">
                                    <div className="item-left">Email</div>
                                    <div className="item-right">{item.email}</div>
                                </div>
                                <div className="w-100 d-row d-flex">
                                    <div className="item-left">Phòng ban</div>
                                    <div className="item-right">{item.department}</div>
                                </div>
                                <div className="w-100 d-row d-flex">
                                    <div className="item-left">Công ty</div>
                                    <div className="item-right">{item.company_name}</div>
                                </div>
                                <div className="w-100 d-row d-flex">
                                    <div className="item-left">Trạng thái</div>
                                    <div className="item-right">
                                        {item.timecheckin ? "Có mặt" : "Vắng mặt"}<br/>
                                        <Moment format="HH:mm DD/MM/YYYY">{item.timecheckin}</Moment>
                                    </div>
                                </div>

                                <div className="w-100 p-2 d-flex">
                                    <button type="button" className="btn btn-sm btn-success w-100" disabled={loading == item.user_id ? true : false} onClick={() => actionCheckin(item.user_id)}>
                                        <i className="fas fa-sign-in-alt"></i> {loading == item.user_id ? <Spinner /> : "Checkin"}</button>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </AkkhorLayout>
    );
}
